import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

// Reports the desktop host's specs (OS / arch / CPU / memory) to the users stack —
// once per session, only on the Electron app, only when signed in. Best-effort.
const USERS_BASE = (process.env.REACT_APP_USERS_API_URL || 'https://users.app.lxop.in').replace(/\/$/, '');

export default function DeviceReporter() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    const getInfo = typeof window !== 'undefined' && window.electronEnv?.systemInfo;
    if (typeof getInfo !== 'function') return;                       // desktop only
    if (sessionStorage.getItem('lxops_device_reported') === '1') return;
    (async () => {
      try {
        const info = await getInfo();
        if (!info) return;
        await api.post('/user/device', info, { baseURL: USERS_BASE });
        sessionStorage.setItem('lxops_device_reported', '1');
      } catch { /* telemetry is best-effort — never disrupt the app */ }
    })();
  }, [user]);
  return null;
}
